var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.display
    ? _c(
        "section",
        { staticClass: "wine-features", attrs: { id: "wine-features-region" } },
        [
          _c(
            "section",
            { staticClass: "wine-feature-actions" },
            [
              _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c(
                          "div",
                          { staticClass: "wine-features-dropdown-display" },
                          [
                            _c(
                              "b-form-select",
                              {
                                staticClass: "wine-features-dropdown",
                                model: {
                                  value: _vm.activePane,
                                  callback: function ($$v) {
                                    _vm.activePane = $$v
                                  },
                                  expression: "activePane",
                                },
                              },
                              _vm._l(_vm.panes, function (paneOption, idx) {
                                return _c(
                                  "b-form-select-option",
                                  {
                                    key: `dropdown-item-${idx}`,
                                    attrs: { value: paneOption.id },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(paneOption.name) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "wine-features-tabs-display" },
                          [
                            _c(
                              "ul",
                              { staticClass: "wine-features-tabs" },
                              _vm._l(_vm.panes, function (paneTab) {
                                return _c(
                                  "li",
                                  {
                                    key: `tab-item-${paneTab.id}`,
                                    staticClass: "tab-item",
                                    class: `${
                                      paneTab.id === _vm.activePane
                                        ? "active"
                                        : ""
                                    }`,
                                    attrs: { tabindex: 0 },
                                    on: {
                                      click: function ($event) {
                                        _vm.activePane = paneTab.id
                                      },
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        _vm.activePane = paneTab.id
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "tab-title" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(paneTab.name) +
                                          "\n                "
                                      ),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activePane && _vm.panes[_vm.activePane]
            ? _c(
                "section",
                { staticClass: "wine-feature-content" },
                [
                  _c(_vm.activeContent, {
                    tag: "component",
                    attrs: {
                      reviews: _vm.reviewsData,
                      awards: _vm.awardsData,
                      "technical-notes": _vm.technicalNotesData,
                      "wine-making-notes": _vm.wineMakingNotesData,
                      "tasting-notes": _vm.tastingNotes,
                      faqs: _vm.faqsData,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }